// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3RL8J","header":"ReportDetails_header__3d2OJ","title":"ReportDetails_title__CxscX","left":"ReportDetails_left__3odcw"};